import { useGetWithRefetch } from '../../../hooks/useFetchEndPoint';
import { FullProgram } from './api/types';

export const useGetProgram = (pk: string, running: boolean = true) => {
  return useGetWithRefetch<FullProgram>(`/api/v1/syllabus/programs/${pk}/`, {
    running,
  });
};
